<template>

<div class="dynamic-table">
  <table class="table table-striped">
    <thead>
      <tr>
        <th v-for="col in cols">
          <span v-on:click="changeSort(col.prop)" v-bind:class="{'sort': (sort.by === col.prop)}">{{col.name}}</span>
          <i class="fas fa-sort-amount-up" v-if="sort.by === col.prop && sort.direction === 'desc'"></i>
          <i class="fas fa-sort-amount-down" v-if="sort.by === col.prop && sort.direction === 'asc'"></i>
        </th>
        <td v-if="onClick"></td>
      </tr>
    </thead>
    <tbody>
      <tr v-for="row in rowData" v-if="rowData.length > 0">
        <td v-for="col in row.data">
          {{col}}
        </td>
        <td class="text-right" @click="onClick(row.id)">
          <button class="btn btn-primary"><i class="fas fa-edit"></i></button>
        </td>
      </tr>
      <tr v-if="rowData.length <= 0">
        <td :colspan="cols.length + (onClick ? 1 : 0)" class="text-center xs-p-20">
          No records to show
        </td>
      </tr>
    </tbody>
    <tfoot v-if="paging.show">
      <tr>
        <td :colspan="cols.length + (onClick ? 1 : 0)" class="xs-pt-20 xs-pb-20">
          <ul class="paging text-center">
            <li><a class="btn btn-default" v-on:click="prevPage" :disabled="paging.pageNum <= 1"><i class="mdi mdi-chevron-left"></i></a></li>
            <li v-for="p in paging.numPages"><a class="btn btn-default" v-on:click="changePage(p)" v-bind:class="{ 'btn-primary': paging.pageNum === p }">{{p}}</a></li> 
            <li><a class="btn btn-default" v-on:click="nextPage" :disabled="paging.pageNum >= paging.numPages"><i class="mdi mdi-chevron-right"></i></a></li>
          </ul>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
</template>

<script>

import _ from 'underscore'

  export default {
    props: {
      data: Array,
      fields: Array,
      pageSize: Number,
      pageNum: Number,
      onClick: Function,
      defaultSort: String
    },

    created() {
      this.sort.by = this.defaultSort ? this.defaultSort : this.fields[0];

      this.resetPaging();
    },

    data() {
      return {
        paging: {
          show: true,
          pageSize: 0,
          pageNum: 0,
          totalCount: 0,
          totalCount: 0,
          numPages: 0
        },
        sort: {
          by: '',
          direction: 'asc'
        }
      }
    },

    computed: {
      cols() {
        let cols = [];
        for (var i = 0; i < this.fields.length; i ++) {
          cols.push({
            name: this.fields[i]
              .replace(/([A-Z])/g, ' $1')
              .replace(/_/g, ' ')
              .replace(/^./, function (str) { return str.toUpperCase(); }),
            prop: this.fields[i]
          })
        }
        return cols;
      },

      rowData() {
        let fields = this.fields;

        let sortedData = this.data;
        if (this.sort.by) {
          sortedData = _.sortBy(sortedData, this.sort.by);
          if (this.sort.direction === 'desc') {
            sortedData.reverse();
          }
        }

        let rows = [];
        for (var i = 0; i < sortedData.length; i++) {
          let d = sortedData[i];
          let cols = {
            id: d.id,
            data: new Array(fields.length)
          };

          Object.keys(d).map(function (key) {
            if (fields.indexOf(key) >= 0) {
              cols.data[fields.indexOf(key)] = d[key];
            }
          });
          
          rows.push(cols);
        }

        let from = ((this.paging.pageNum - 1) * this.paging.pageSize);
        let to = (this.paging.pageNum * this.paging.pageSize);
        rows = rows.slice(from, to);

        return rows;
      },
    },

    methods: {
      resetPaging() {
        this.paging = {
          show: true,
          pageSize: this.pageSize || 12,
          pageNum: this.pageNum || 1,
          totalCount: this.data.length,
          totalCount: 0,
          numPages: 0
        }

        this.paging.totalCount = this.data.length;
        this.paging.numPages = this.paging.totalCount > 0 ? Math.ceil(this.paging.totalCount / this.paging.pageSize) : 0;
        this.paging.show = this.paging.numPages > 1;
      },
      nextPage() {
        if (this.paging.pageNum < this.paging.numPages) {
          this.paging.pageNum += 1;
        }
      },
      prevPage() {
        if (this.paging.pageNum > 1) {
          this.paging.pageNum -= 1;
        }
      },
      changePage(p) {
        this.paging.pageNum = p;
      },
      changeSort(prop) {
        this.sort.direction = prop === this.sort.by ? (this.sort.direction === 'asc' ? 'desc' : 'asc') : 'asc';
        this.sort.by = prop;
      }
    },
    watch: {
      data: function (val) {
        this.resetPaging();
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  thead {background:#DFDFDF;font-weight:bold;}
  thead th span {cursor:pointer;}
  thead th span:hover,
  thead th span.sort {color:#4285f4;}

  .paging ul, .paging li { margin: 0px; padding: 0px; list-style: none; }
  .paging li {display:inline;}
  .paging li:first-child {margin-right:-4px;}
  .paging li:first-child a { border-radius: 2px 0px 0px 2px; }
  .paging li a { border-radius: 0px;}
  .paging li:last-child {margin-left:-4px;}
  .paging li:last-child a { border-radius: 0px 2px 2px 0px;}
  .paging li a.btn-primary {cursor:default;}


</style>



// WEBPACK FOOTER //
// DynamicTable.vue?6e2a2a0f